import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Home from '../components/Home'
import styles from '../styles/main.module.css';

class Index extends React.Component {

  render() {
    const siteTitle = "Choose the right course to aim higher | Uni Village Education";
    const description = "Uni Village Education is an online education service provider Malaysia. " +
       "We provide educational consulting services to help you find your right course!";
       console.log('----')
       console.log(siteTitle);
       console.log('----')
    return (
      <div>
        <Helmet>
          <title>{siteTitle}</title>
          <meta name="description" content={description} />
        </Helmet>
        <Home />
      </div>
    )
  }
}

Index.propTypes = {
  route: React.PropTypes.object,
}

export default Index



// WEBPACK FOOTER //
// ./src/pages/index.js